module.exports = __webpack_public_path__ + "static/media/ic_graphic_no_review@2x.11351341.png";